/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['boxErrorMsg', 'blockMsg', 'blockInfoMsg', 'blockErrorMsg'] }] */
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { ZawSubsidyReissueEligibility } from 'constants/zaw';
import { AriaLiveTee } from 'components/common/AriaLive';

import returnsMessagesCSS from 'styles/containers/returns/returnsMessages.scss';
import css from 'styles/components/account/returns/zawInfoBanner.scss';

const INITIATE_MESSAGE =
  'This return has item(s) paid for with a Zappos at Work subsidy. Your subsidy will be available for reuse shortly after you submit your return. Please note that returns must be unworn with the original tags and original packaging.';
const CONFIRMATION_MESSAGE =
  'This return has item(s) paid for with a Zappos At Work subsidy. Your subsidy will be available for reuse shortly. Please note that returns must be unworn with the original tags and original packaging.';

const TRANSITION_CLASSNAMES = {
  appear: css.zawInfoBannerAppear,
  enter: css.zawInfoBannerEnter,
  enterActive: css.zawInfoBannerEnterActive,
  enterDone: css.zawInfoBannerEnterDone
};

export const ZawInfoBanner = ({ enabled, zawSubsidyReissueEligibility, isConfirmationPage }) => {
  const isBannerVisible = enabled && zawSubsidyReissueEligibility === ZawSubsidyReissueEligibility.SUBSIDY_WILL_BE_REISSUED;

  return (
    <CSSTransition in={isBannerVisible} timeout={400} classNames={TRANSITION_CLASSNAMES}>
      <div className={`${returnsMessagesCSS.boxInfoMsg} ${css.zawInfoBanner}`}>
        <AriaLiveTee>{isConfirmationPage ? CONFIRMATION_MESSAGE : INITIATE_MESSAGE}</AriaLiveTee>
      </div>
    </CSSTransition>
  );
};

export default ZawInfoBanner;
